import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x-gray.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-prev.svg'
import _imports_2 from '@/app/ui/assets/svg/frame-image.svg'
import _imports_3 from '@/app/ui/assets/svg/chevron-next.svg'


const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-black-lp-50"
}
const _hoisted_2 = {
  class: "bg-white rounded-lg overflow-hidden",
  style: {"max-height":"400px","height":"100%","max-width":"800px"}
}
const _hoisted_3 = { class: "flex items-center space-x-3 justify-between p-4 border-b-2 border-gray-lp-200" }
const _hoisted_4 = { class: "text-xl font-bold text-black-lp-300" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = { class: "relative p-4" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = {
  key: 0,
  class: "bg-blue-lp-100 rounded-lg overflow-hidden px-6",
  style: {"height":"280px"}
}
const _hoisted_11 = { class: "font-semibold text-2xl text-white px-4 pt-4 pb-2" }
const _hoisted_12 = /*#__PURE__*/_createVNode("hr", { class: "border-white/20" }, null, -1)
const _hoisted_13 = { class: "flex items-start gap-4 p-4" }
const _hoisted_14 = { class: "text-white text-lg flex-1 font-medium" }
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "absolute inset-0 w-full",
  alt: "frame"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "absolute bottom-0 w-full",
  style: {"transform":"rotate(180deg)"},
  alt: "frame"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_19 = { class: "flex justify-center gap-2 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("Panduan lampiran file - ") + _ctx.$t(_ctx.guide?.title)), 1),
            _createVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
              class: "text-gray-lp-600 hover:text-black-lp-300"
            }, [
              _hoisted_5
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _withDirectives(_createVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.prevSlide && _ctx.prevSlide(...args))),
                class: "absolute left-0 z-10 p-2 rounded-full bg-white shadow-md text-gray-600 hover:text-black-lp-300",
                disabled: _ctx.currentSlide === 0
              }, [
                _hoisted_8
              ], 8, ["disabled"]), [
                [_vShow, _ctx.guide.carousel_list.length > 1]
              ]),
              _createVNode("div", _hoisted_9, [
                (_ctx.guide)
                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                      _createVNode("p", _hoisted_11, _toDisplayString(_ctx.$t(_ctx.guide.carousel_list[_ctx.currentSlide]?.title)), 1),
                      _hoisted_12,
                      _createVNode("div", _hoisted_13, [
                        _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t(_ctx.guide.carousel_list[_ctx.currentSlide]?.description)), 1),
                        _createVNode("div", _hoisted_15, [
                          _createVNode("img", {
                            src: _ctx.guide.carousel_list[_ctx.currentSlide]?.image_url,
                            class: "w-300px rounded-lg object-contain",
                            style: {"height":"190px"},
                            alt: "image_lampiran"
                          }, null, 8, ["src"]),
                          _hoisted_16,
                          _hoisted_17
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.nextSlide && _ctx.nextSlide(...args))),
                class: "absolute right-0 z-10 p-2 rounded-full bg-white shadow-md text-gray-600 hover:text-black-lp-300",
                disabled: _ctx.currentSlide >= (_ctx.guide?.carousel_list.length ?? 0) - 1
              }, [
                _hoisted_18
              ], 8, ["disabled"]), [
                [_vShow, _ctx.guide.carousel_list.length > 1]
              ])
            ]),
            _withDirectives(_createVNode("div", _hoisted_19, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.guide?.carousel_list ?? [], (_, index) => {
                return (_openBlock(), _createBlock("button", {
                  key: index,
                  onClick: ($event: any) => (_ctx.currentSlide = index),
                  class: ["w-2 h-2 rounded-full transition-colors", 
              _ctx.currentSlide === index ? 'bg-blue-lp-100 w-7' : 'bg-gray-lp-1400'
            ]
                }, null, 10, ["onClick"]))
              }), 128))
            ], 512), [
              [_vShow, _ctx.guide.carousel_list.length > 1]
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}